import * as emotion from "./emotion"
/**
 * 机器人会话接口
 * 文档：
 * http://docs.ruyi.ai/502931
 */
export class ruyi {
    key = "89680f5a-899c-42ba-91d9-f786864085c8"; //默认机器人ID
    name = "T9"; //机器人的默认名字
    constructor(name, key) {//构造函数
        if (key) {
            this.key = key
        }
        if (name) {
            this.name = name
        }
    }
    /**
     * 发送消息
     * @param {*} msg 消息内容
     * @param {*} userid 用户ID
     * 返回p
     */
    send (msg, userid) {
        var that = this
        return new Promise(function (resolve, reject) {
            // URL查询参数实例，直接对象格式，省去了很多麻烦
            var reqParams = new URLSearchParams({
                app_key: that.key,	// 机器人ID
                user_id: userid,	// 会话用户ID
                q: msg	// 输入的内容
                //reset_session 如果为true，重置当前对话session，忘记短期对话记忆
                //context 	用户当前上下文信息。JSON字符串格式。
            })

            // 头信息实例
            var reqHeader = new Headers()
            reqHeader.append('Content-Type', 'application/x-www-form-urlencoded')
            // reqHeader.append('Content-Type', 'application/json');

            var xieyi = "https://"
            var protocolStr = document.location.protocol
            if (protocolStr == "https:") {
                xieyi = "https://"
            }
            // 请求实例
            var request = new Request(xieyi + 'api.ruyi.ai/v1/message?' + reqParams, {
                method: 'GET'	// 请求方式【只接受GET请求】
            })

            fetch(request)	// 发送请求
                .then(res => res.json())	// 转为 JSON
                .then(res => {	// 处理数据

                    // console.log("回复",res);

                    // 普通结果
                    var retval = res.result.intents[0].result.text.replace(/\&name/g, that.name)

                    // 微信端结果
                    // var retval = res.result.intents[0].outputs[0].property.text;

                    // 智能硬件端结果
                    // var retval = res.result.intents[0].outputs[1].property.text;

                    var ret = {
                        text: retval
                    }
                    console.log('property智能机器人报错', res.result)
                    if (res.result.intents[0].outputs[1]) {
                        var emoti = res.result.intents[0].outputs[1].property.emotion
                        ret.emotion = that.emotion2exchange(emoti)
                    } else {
                        ret.emotion = that.emotion2exchange()
                    }

                    resolve(ret)
                })
        })
    }

    /**
     * 情感关键词置换
     */
    emotion2exchange (emoti) {
        var emotionS = emotion.emotion
        var emojiid = ""
        for (var i = 0; i < emotionS.length; i++) {
            if (emotionS[i].bot && emotionS[i].bot == emoti) {
                emojiid = emotionS[i].id
                break
            }
        }
        return emojiid
    }
}